import { ApiService } from '../Services/APIService';
import { ENDPOINTS, DOCKER_SUMMARY_URL } from '../Utils/APIConstants';
import { StorageUtils } from "../Utils/StorageUtils";  

export const LinkService = {
  createLink: async (linkData) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;

    // Set the token in ApiService
    ApiService.setAuthToken(token);

    // Make the API call
    return ApiService.post(ENDPOINTS.CREATE_LINK, linkData);
  },

  fetchAllLinks: async (status) => {
    // Retrieve the token from StorageUtils
    const userData = StorageUtils.getUserData();
    const token = userData?.token;
    
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Set the token in ApiService
    ApiService.setAuthToken(token);

    try {
      // Make the API call
      const params = status ? { status } : undefined;
      const response = await ApiService.get(ENDPOINTS.CREATE_LINK, params);
      return response;
    } catch (error) {
      // Handle token expiration
      if (error.response?.status === 401 || error.response?.status === 403) {
        StorageUtils.removeUserData();
        window.location.href = '/login';
        return;
      }
      
      throw error;
    }
  },

  fetchLinksByStatus: async (status) => {
    return LinkService.fetchAllLinks(status);
  },

  fetchLinkStatus: async (linkId) => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.get(`${ENDPOINTS.CREATE_LINK}/${linkId}/status`);
  },

  fetchLinkStatuses: async (linkIds = []) => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    const idsParam = Array.isArray(linkIds) ? linkIds.filter(Boolean).join(',') : linkIds;
    return ApiService.get(ENDPOINTS.LINK_STATUS, { ids: idsParam });
  },

  deleteLink: async (linkId) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;

    // Set the token in ApiService
    ApiService.setAuthToken(token);

    // Make the API call
    //return ApiService.post(ENDPOINTS.CREATE_LINK, linkData);
    return ApiService.delete(`${ENDPOINTS.CREATE_LINK}/${linkId}`); // Assuming linkData contains the id of the link to delete
    
  },

  logClick: async (slugData) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;

    // Set the token in ApiService
    ApiService.setAuthToken(token);

    // Make the API call
    return ApiService.post(ENDPOINTS.LOG_CLICK, slugData);
  },

  logSummaryClick: async (slugData) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;

    // Set the token in ApiService
    ApiService.setAuthToken(token);

    // Make the API call
    return ApiService.post(ENDPOINTS.SUMMARY_CLICK, slugData);
  },

  regenerateSummary: async (slug) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;
    
    if (!token) {
      throw new Error('Authentication required');
    }

    // Set the token in ApiService
    ApiService.setAuthToken(token);

    // Make the API call using ApiService (which respects debug mode)
    const response = await ApiService.post(`${ENDPOINTS.SUMMARY}/${slug}/regenerate`, {});
    return response.data;
  },

  // Add viewer to summary
  addSummaryViewer: async (slug, email) => {
    const userData = StorageUtils.getUserData();
    const token = userData?.token;
    
    if (!token) {
      throw new Error('Authentication required');
    }

    ApiService.setAuthToken(token);
    const response = await ApiService.post(
      `/summaries/${slug}/access/viewers`,
      { email }
    );
    return response.data;
  },

  // Remove viewer from summary
  removeSummaryViewer: async (slug, email) => {
    const userData = StorageUtils.getUserData();
    const token = userData?.token;
    
    if (!token) {
      throw new Error('Authentication required');
    }

    ApiService.setAuthToken(token);
    const response = await ApiService.delete(
      `/summaries/${slug}/access/viewers/${encodeURIComponent(email)}`
    );
    return response.data;
  },

  // Get viewers list
  getSummaryViewers: async (slug) => {
    const userData = StorageUtils.getUserData();
    const token = userData?.token;
    
    if (!token) {
      throw new Error('Authentication required');
    }

    ApiService.setAuthToken(token);
    const response = await ApiService.get(
      `/summaries/${slug}/access/viewers`
    );
    return response.data;
  },

  // Toggle privacy
  toggleSummaryPrivacy: async (slug, isPrivate) => {
    const userData = StorageUtils.getUserData();
    const token = userData?.token;
    
    if (!token) {
      throw new Error('Authentication required');
    }

    console.log('🔐 [toggleSummaryPrivacy] Attempting to toggle privacy:', { slug, isPrivate, token: token?.substring(0, 20) + '...' });
    
    ApiService.setAuthToken(token);
    try {
      const response = await ApiService.patch(
        `/summaries/${slug}/access/privacy`,
        { isPrivate }
      );
      console.log('✅ [toggleSummaryPrivacy] Success:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [toggleSummaryPrivacy] Error:', error.response?.data || error.message);
      throw error;
    }
  }

};
